import React from "react";

import ReunionHero from "./modules/reunion/ReunionHero";
import ReunionUseCases from "./modules/reunion/ReunionUseCases";
import ReunionWorkflow from "./modules/reunion/ReunionWorkflow";
import ReunionFeatures from "./modules/reunion/ReunionFeatures";
import ReunionRules from "./modules/reunion/ReunionRules";
import ReunionCTA from "./modules/reunion/ReunionCTA";
import ReunionFooter from "./modules/reunion/ReunionFooter";

const ReunionHome = () => {
  return (
    <div className="min-h-screen bg-[#0a0a0f] text-white overflow-x-hidden font-sans">
      <ReunionHero />
      <ReunionUseCases />
      <ReunionWorkflow />
      <ReunionFeatures />
      <ReunionRules />
      <ReunionCTA />
      <ReunionFooter />
    </div>
  );
};

export default ReunionHome;